import * as z from "zod";

const estimatedEmailCost = z.object({ costPerThousand: z.number() });

export const getEstimatedEmailCost = {
  name: "getEstimatedEmailCost" as const,
  input: z.null(),
  output: estimatedEmailCost.nullable(),
};
